export {default} from './Tooltip';



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Tooltip/index.js